import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { leadService } from '../../services/api';
import { Input, Select, Button, Toast } from '../../components/ui';

const CreateLeadForm = ({ onClose, onCreated, courses, leadSources, counsellors }) => {
  const { dark } = useTheme();
  const { user } = useAuth();
  const [form, setForm] = useState({
    fullName: '', mobile: '', email: '', course: '', leadSource: '',
    priority: 'medium', qualification: '', city: '', state: '', remarks: '', assignedCounsellor: '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const isCounsellor = user?.role?.code === 'COUNSELLOR';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName || !form.mobile || !form.course || !form.leadSource) {
      setToast({ msg: 'Please fill in all required fields (*)', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const payload = { ...form };
      if (isCounsellor) payload.assignedCounsellor = user._id;
      await leadService.create(payload);
      setToast({ msg: 'Lead created successfully!', type: 'success' });
      if (onCreated) onCreated();
      setTimeout(onClose, 1500);
    } catch (err) {
      setToast({ msg: err.response?.data?.message || err.message || 'Error creating lead', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const f = (field) => ({ value: form[field], onChange: e => setForm({ ...form, [field]: e.target.value }) });

  return (
    <div>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
          <Input label="Full Name *" {...f('fullName')} placeholder="Enter full name" />
          <Input label="Mobile Number *" {...f('mobile')} placeholder="Enter mobile" />
          <Input label="Email" {...f('email')} placeholder="Enter email" type="email" />
          <Select label="Course *" {...f('course')} options={courses.map(c => ({ value: c._id, label: c.name }))} />
          <Select label="Lead Source *" {...f('leadSource')} options={leadSources.map(s => ({ value: s._id, label: s.name }))} />
          <Select label="Priority" {...f('priority')} options={['low', 'medium', 'high', 'urgent']} />
          <Input label="Qualification" {...f('qualification')} placeholder="e.g. B.Tech" />
          <Input label="City" {...f('city')} placeholder="Enter city" />
          <Input label="State" {...f('state')} placeholder="Enter state" />
          {!isCounsellor && (
            <Select label="Assigned Counsellor" {...f('assignedCounsellor')} options={counsellors.map(c => ({ value: c._id, label: `${c.firstName} ${c.lastName}` }))} />
          )}
        </div>
        {!isCounsellor && (
          <div style={{ fontSize: 11, color: dark ? '#64748B' : '#94A3B8', marginBottom: 4 }}>
            Leave Assigned Counsellor blank to auto-route by course specialization.
          </div>
        )}
        <Input label="Remarks" {...f('remarks')} placeholder="Additional information..." />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <Button variant="outline" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={loading}>Create Lead</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateLeadForm;
